module.exports = __webpack_public_path__ + "img/Laboratorio-envios.3bc54402.png";